import { Link } from "react-router-dom";
import { useState } from "react";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="flex flex-col items-center">
              <div className="flex items-center space-x-1">
                <span className="text-2xl font-bold text-amber-700">QBi</span>
                <span className="text-xl text-stone-600">floor.</span>
              </div>
              <div className="bg-stone-700 text-white text-xs px-2 py-1 rounded-md font-medium">
                DER PARKETTMEISTER
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-stone-600 hover:text-stone-800 font-medium transition-colors duration-200"
            >
              Startseite
            </Link>
            <a 
              href="#services" 
              className="text-stone-600 hover:text-stone-800 font-medium transition-colors duration-200"
            >
              Leistungen
            </a>
            <a 
              href="#about" 
              className="text-stone-600 hover:text-stone-800 font-medium transition-colors duration-200"
            >
              Über uns
            </a>
            <Link 
              to="/contact" 
              className="bg-stone-600 hover:bg-stone-700 text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200"
            >
              Kontakt
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-stone-600 hover:text-stone-800 hover:bg-stone-100"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-stone-200">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-stone-600 hover:text-stone-800 font-medium transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Startseite
              </Link>
              <a 
                href="#services" 
                className="text-stone-600 hover:text-stone-800 font-medium transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Leistungen
              </a>
              <a 
                href="#about" 
                className="text-stone-600 hover:text-stone-800 font-medium transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Über uns
              </a>
              <Link 
                to="/contact" 
                className="bg-stone-600 hover:bg-stone-700 text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200 inline-block text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Kontakt
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
} 